const gtpLoad = () => {
    const script = document.createElement('script');
    script.innerHTML = '!function(w,d,s,u){if(w.oaiq)return;var q=function(){q.q.push(arguments)};q.q=[];w.oaiq=q;var j=d.createElement(s);j.async=1;j.src=u;var f=d.getElementsByTagName(s)[0];f.parentNode.insertBefore(j,f)}(window,document,"script","https://bzrcdn.openai.com/sdk/oaiq.min.js");oaiq("init",{pixelId:"KuPyXi5mR8XMJ871Euorvz",debug:true});';

    document.head.appendChild(script);
};

const gtpPurchase = ({
    number,
    items,
    total: {
        grand_total,
    },
}) => {
    oaiq('measure', 'order_created', {
        type: 'contents',
        amount: grand_total.value,
        currency: grand_total.currency,
        contents: items.map(({
            product: {
                sku,
                name,
            },
            prices: {
                row_total: { value }
            },
            quantity,
        }) => ({
            id: sku,
            name: name,
            content_type: 'product',
            quantity: quantity,
            amount: value,
        })),
    }, { event_id: number });
};

const gtpBeginCheckout = ({
    items,
    prices: {
        grand_total = {},
    } = {},
}) => {
    oaiq('measure', 'checkout_started', {
        type: 'contents',
        amount: grand_total.value,
        currency: grand_total.currency,
        contents: items.map(({
            product: {
                sku,
                name,
            },
            prices: {
                row_total: { value }
            },
            quantity,
        }) => ({
            id: sku,
            name: name,
            content_type: 'product',
            quantity: quantity,
            amount: value,
        })),
    });
};

const gtpAddToCart = ({
    cartItems,
    addedItems,
    cart: {
        prices: {
            grand_total = {}
        } = {}
    } = {},
}) => {
    const itemsList = [];

    addedItems.forEach(({ sku: addedSku, quantity }) => {
        const { product: { sku, name, price_range } } = cartItems.find(({ product: { sku } }) => sku === addedSku);

        itemsList.push({ sku, name, price_range, quantity });
    });

    const items = itemsList.map(({
        sku,
        name,
        price_range: {
            minimum_price: {
                regular_price: { value, currency },
            }
        },
        quantity,
    }) => ({
        id: sku,
        name: name,
        content_type: 'product',
        quantity: quantity,
        amount: value,
        currency
    }));

    oaiq('measure', 'items_added', {
        type: 'contents',
        amount: grand_total.value,
        currency: grand_total.currency,
        contents: items,
    });
};

const gtpPageView = title => {
    oaiq('measure', 'page_viewed', {
        type: 'contents',
        contents: [
            {
                id: window.location.pathname,
                name: title,
                content_type: 'page',
            },
        ],
    });
};

export {
    gtpLoad,
    gtpPurchase,
    gtpBeginCheckout,
    gtpAddToCart,
    gtpPageView,
}
